/**
 * Application-wide constants and configuration values
 * Centralizes magic numbers for easier maintenance and configuration
 */

// Chat Configuration
export const CHAT_MESSAGE_LIMIT = 100; // Number of recent messages to load
export const CHAT_MESSAGE_MAX_LENGTH = 500; // Maximum characters per message
export const CHAT_RATE_LIMIT_WINDOW = 10; // Seconds
export const CHAT_RATE_LIMIT_MAX = 3; // Max messages per window

// Session Configuration
export const SESSION_REFRESH_INTERVAL = 50 * 60 * 1000; // 50 minutes in milliseconds
export const TOKEN_EXPIRY_TIME = 60 * 60 * 1000; // 60 minutes in milliseconds

// HLS Player Configuration
export const HLS_ENABLE_WORKER = true;
export const HLS_LOW_LATENCY_MODE = true;

// Stream Configuration
export const STREAM_OFFLINE_ERROR_CODE = 204;

// UI Configuration
export const MOBILE_BREAKPOINT = 768; // pixels

// Time Formats
export const TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
};

// React Query Configuration
export const REACT_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000, // 5 minutes
  gcTime: 10 * 60 * 1000, // 10 minutes
  retry: 1,
  refetchOnWindowFocus: false,
} as const;

// Cloudflare Stream URL patterns
export const CLOUDFLARE_STREAM_REGEX = /cloudflarestream\.com\/([a-f0-9]+)(?:\/|$)/;
export const CLOUDFLARE_STREAM_MANIFEST_PATH = '/manifest/video.m3u8';
export const CLOUDFLARE_STREAM_IFRAME_PATH = '/iframe';
